<template>
    <div class="overflow-y-auto lg:overflow-auto">
        <div class="lg:hidden text-xl text-link font-semibold pb-4">
            {{ t('product.tabsIngredients.ingredients') }}
        </div>

        <ProductIngredients :custom-fields="customFields" />
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    customFields?: object | undefined
}>()

</script>
